import { BreakpointMin } from '@utils/breakpoint-min.service';
import { RelewiseRetailMediaVariation } from '@core/services/relewise/relewise-tracking.model';

export const mapToRelewiseVariation = (breakpointMin?: BreakpointMin): RelewiseRetailMediaVariation => {
    if (breakpointMin?.isMobile || breakpointMin?.isMobileLarge) {
        return 'MOBILE';
    }

    if (breakpointMin?.isTablet || breakpointMin?.isTabletOrSmaller) {
        return 'TABLET';
    }

    return 'DESKTOP';
};
